import { LanguageCodeEnum } from '../../common/enums/common.enum';

export type LocalizedTitle = {
  [LanguageCodeEnum.ENG]: string;
} & {
  [K in Exclude<LanguageCodeEnum, LanguageCodeEnum.ENG>]?: string;
};

export const pickTranslations = (source: Record<string, string>): Record<LanguageCodeEnum, string> =>
  Object.values(LanguageCodeEnum).reduce((acc, key) => ({ ...acc, [key]: source[key] ?? '' }), {} as Record<LanguageCodeEnum, string>);

export const emptyTranslations = (): Record<LanguageCodeEnum, string> =>
  Object.values(LanguageCodeEnum).reduce((acc, key) => ({ ...acc, [key]: '' }), {} as Record<LanguageCodeEnum, string>);
